import {
  Component,
  effect,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import BezierEasing from 'bezier-easing';
import {
  NgCircleProgressModule,
  CircleProgressOptions,
} from 'ng-circle-progress';
import { animateElement } from '@core/utils/deprecated.utils.js';
import { ModalService } from '@features/modals/services/modal.service.js';
import { CostComponent } from '../../../core/components/cost/cost.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { JackpotHrService } from '../jackpot-hr.service';

@Component({
  selector: 'app-jackpot-wheel',
  templateUrl: './jackpot-wheel.component.html',
  styleUrls: ['./jackpot-wheel.component.scss'],
  standalone: true,
  imports: [NgCircleProgressModule, CostComponent, SvgIconComponent],
  providers: [
    {
      provide: CircleProgressOptions,
    },
  ],
})
export class JackpotWheelComponent {
  @ViewChild('wheel', { read: ElementRef, static: true }) wheel!: ElementRef;
  @ViewChild('usersWheel', { read: ElementRef, static: true })
  usersWheel!: ElementRef;

  constructor(
    public jackpotService: JackpotHrService,
    private modalService: ModalService
  ) {
    effect(() => {
      if (
        this.jackpotService.jackpot()?.status === 'running' ||
        this.jackpotService.jackpot()?.status === 'awaiting' ||
        this.jackpotService.jackpot()?.status === 'finished'
      ) {
        this.resetWheel();
      }

      if (this.jackpotService.jackpot()?.status === 'rolling') {
        this.rollJackpot();
      }
    });
  }

  ngOnInit(): void {
    this.resetWheel();
  }

  rollJackpot() {
    const duration = this.jackpotService.timer();
    const winAngle = this.calculateWinAngle();
    animateElement(
      (p: number) => {
        this.usersWheel.nativeElement.style.transform = `translate(50%, 50%) rotate(${
          p * winAngle
        }deg)`;
      },
      duration * 1000,
      BezierEasing(0, 0.75, 0, 1)
    );
  }

  resetWheel() {
    this.usersWheel.nativeElement.style.transform = `translate(50%, 50%) rotate(0deg)`;
  }

  @HostListener('window:resize')
  onResize() {}

  calculateStroke(radiusPercentage: number, percentage: number) {
    return `${
      radiusPercentage * 2 * Math.PI * ((100 - percentage) / 100 + 1)
    }%`;
  }

  calculateBetRotate(betIndex: number) {
    let chance = 0;
    for (let i = 0; i < betIndex; i++) {
      chance += this?.jackpotService?.jackpot()?.bets?.[i]?.chances || 0;
    }
    return `rotate(${(chance / 100) * 360})`;
  }

  imageLocation(percentage: number) {
    const angle = (360 * (percentage / 100)) / 2;
    const angleCorrection = -90;
    const a = (angle + angleCorrection) * (Math.PI / 180);
    const width = this.wheel.nativeElement.clientWidth;
    return `translate(${width * 0.4 * Math.cos(a)}, ${
      width * 0.4 * Math.sin(a)
    })`;
  }

  imageRotate(percentage: number) {
    const degree = (percentage / 100 / 2) * 360;
    return `rotate(${degree})`;
  }

  openJoinGame() {
    this.modalService.openModal('DepositJackpotModal');
  }

  calculateWinAngle() {
    if (this.jackpotService.jackpot()?.status !== 'rolling') {
      return 0;
    }

    const endDegree = 360 * (this.jackpotService.jackpot()?.module ?? 1);
    return -(endDegree + 360 * 6);
  }
}
